var heading_default = {
  "fontElementMap": "mmsMC",
  "elementSpacing": "yelXh",
  "headerOne": "_4shDq yelXh",
  "headerTwo": "TFeUR yelXh",
  "headerThree": "_8J6VB yelXh",
  "headerFour": "lO0Ae yelXh",
  "headerFive": "eu33K yelXh",
  "headerSix": "rv9qp yelXh",
  "child": "f6nDn"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
